import { HStack, Text } from "@chakra-ui/react"
import Pathicon from "@pathwright/ui/src/components/pathicon/Pathicon"
import RegisterHeader from "join/components/RegisterHeader"
import RegisterDisplayPrice from "./RegisterDisplayPrice"
import "./RegisterFlowHeader.css"

const RegisterFlowHeader = ({ resource, offering, invitation, onClose }) => (
  <RegisterHeader
    className="RegisterFlowHeader"
    resource={resource}
    invitation={invitation}
    onClose={onClose}
  >
    {offering && !offering.is_curriculum ? (
      <span>{offering.name}</span>
    ) : undefined}
    {offering && !offering.is_curriculum ? (
      <HStack as="span">
        <Pathicon icon="group-2" />
        <Text as="span" ml="-1" color="inherit">
          {offering.seats_filled}
        </Text>
      </HStack>
    ) : undefined}
    <RegisterDisplayPrice />
  </RegisterHeader>
)

RegisterFlowHeader.displayName = "RegisterFlowHeader"

export default RegisterFlowHeader
